import React from 'react'

function Footer() {

    const footerLinks = [
        {
            title: "Contact Us",
            url: "/"
        },
        {
            title: "Privacy",
            url: "/"
        },
        {
            title: "Legal",
            url: "/"
        },
        {
            title: "Policy",
            url: "/"
        }
    ]


  return (
    <footer className="flex flex-col gap-4 md:gap-0 md:flex-row justify-between p-5">
        <h2>Copyright &copy; {(new Date).getFullYear()} UFarmX LLC. All Rights Reserved</h2>

        <div>
            <ul className="flex gap-5 cursor-pointer">
                {footerLinks.map(link => <li key={link.title}>{link.title}</li>)}
            </ul>

        </div>
    </footer>
  )
}

export default Footer